import { Routes } from '@angular/router';
import { AcRouterOutletComponent } from '@shared/ui-components/ac-router-outlet/ac-router-outlet.component';
import { societyAccessGuard } from '@core/guards/society-access.guard';
import { installationAccessGuard } from '@core/guards/installation-access.guard';

export enum MyServicesRouteAliases {
  SOCIETY = 'societyAlias',
  INSTALLATION = 'installationAlias',
}

export enum MyServicesRouteNames {
  CONTRACT = 'contract',
  SEPA = 'sepa',
}

export const MY_SERVICES_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'listing',
  },
  {
    path: 'listing',
    loadComponent: () => import('@pages/my-services/my-services-listing/my-services-listing.page').then((p) => p.MyServicesListingPage),
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: `:societyId`,
    data: {
      breadcrumb: {
        label: (resolvedId: string) => resolvedId,
        alias: MyServicesRouteAliases.SOCIETY,
      },
    },
    canActivate: [societyAccessGuard],
    component: AcRouterOutletComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@pages/my-services/my-services-individual-society/individual-society.page').then((p) => p.IndividualSocietyPage),
      },
      {
        path: `:cups`,
        loadComponent: () =>
          import('@pages/my-services/my-services-individual-installation/individual-installation.page').then(
            (p) => p.IndividualInstallationPage
          ),
        data: {
          breadcrumb: {
            label: (resolvedId: string) => resolvedId,
            alias: MyServicesRouteAliases.INSTALLATION,
          },
        },
        canActivate: [installationAccessGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@pages/my-services/my-services-individual-installation/routed/individual-installation-data-container.component').then(
                (p) => p.IndividualInstallationDataContainerComponent
              ),
          },
          {
            path: MyServicesRouteNames.CONTRACT,
            data: {
              breadcrumb: 'BASE.CONTRACT',
            },
            loadComponent: () =>
              import(
                '@pages/my-services/my-services-individual-installation/routed/individual-installation-contract-container.component'
              ).then((p) => p.IndividualInstallationContractContainerComponent),
          },
          {
            path: MyServicesRouteNames.SEPA,
            data: {
              breadcrumb: 'GENERAL.SEPA',
            },
            loadComponent: () =>
              import('@pages/my-services/my-services-individual-installation/routed/individual-installation-sepa-container.component').then(
                (p) => p.IndividualInstallationSepaContainerComponent
              ),
          },
        ],
      },
    ],
  },
];
